import React, { useMemo, useState, useEffect } from 'react'
import { useLocation } from 'react-router-dom'
import StayForm from '../../ui/searchForms/StayForm'
import { useDispatch, useSelector } from 'react-redux'
import { AppDispatch, RootState } from '../../../store'
import { filterPlaces } from '../../../features/admin/placeSlice'
import PlaceCard from '../PlaceCard'
import InnerLoading from '../../ui/InnerLoading'
import { CiFilter } from 'react-icons/ci'
import { useTranslation } from 'react-i18next'
import { FaArrowLeftLong } from 'react-icons/fa6'
import MapView from '../MapView'
import FiltersSidebar from '../FiltersSidebar'
import Pagination from '../../ui/Pagination'
import { useSEO } from '../../../custom hooks/useSEO'

const SearchResult = () => {
	const { t } = useTranslation()
	const { t: tSeo } = useTranslation("seo");

	const seo = useSEO({
		title: tSeo("staySearchResult.title"),
		description: tSeo("staySearchResult.description")
	});
	const location = useLocation()
	const query = useMemo(() => new URLSearchParams(location.search), [location.search]);
	const numberOfPlaceRooms: number = 1
	const numberOfHalls: number = 1

	const destination = query.get("destination") || "";
	const checkIn = query.get("checkIn") || null;
	const checkOut = query.get("checkOut") || null;
	const rate = Number(query.get("rate")) || 0;
	const subCategoryId = Number(query.get("subCategoryId")) || 0;
	const numberOfRooms =
		subCategoryId === 1
			? query.get("numberOfRooms")
				? Number(query.get("numberOfRooms"))
				: undefined
			: undefined;
	const dispatch = useDispatch<AppDispatch>()
	const { searchRuselt, pagination, loading } = useSelector((state: RootState) => state.placeSlice)
	const [openFilter, setOpenFilter] = useState(false);
	const [mapView, setMapView] = useState(false);
	const { user } = useSelector((state: RootState) => state.user);

	const [filters, setFilters] = useState({
		subCategoryId: subCategoryId,
		userId: user?.id,
		type: 'Stay',
		checkIn: checkIn,
		checkOut: checkOut,
		rate: rate,
		numberOfRooms: subCategoryId === 1 ? numberOfRooms : undefined,
		numberOfPlaceRooms: subCategoryId !== 1 ? numberOfPlaceRooms : undefined,
		numberOfHalls: subCategoryId !== 1 ? numberOfHalls : undefined,
		location: destination,
		services: [] as number[],
	})


	useEffect(() => {
		const newFilters = {
			subCategoryId: subCategoryId || 0,
			userId: user?.id,
			type: 'Stay',
			checkIn: checkIn || null,
			checkOut: checkOut || null,
			rate: rate || 0,
			location: destination || '',
			services: [],
			numberOfRooms: filters.subCategoryId === 1 ? numberOfRooms : undefined,
			numberOfPlaceRooms: subCategoryId !== 1 ? numberOfPlaceRooms : undefined,
			numberOfHalls: subCategoryId !== 1 ? numberOfHalls : undefined,
		};

		setFilters(newFilters);
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [user?.id, destination, checkIn, checkOut, rate, subCategoryId]);

	useEffect(() => {


		dispatch(filterPlaces({ filters, page: 1 }));
	}, [dispatch, filters]);


	return (
		<div className='bg-white'>
			{seo}
			<div className=' green-hero flex-center  main-prop xs:h-full md:h-[70vh] padding-container'>
				<div className=' rounded-lg bg-white mt-10'>
					<StayForm />
				</div>
			</div>

			<div className='main-prop  padding-container'>
				<button onClick={() => setOpenFilter(!openFilter)} className=' xs:flex md:hidden mb-3 w-full bg-white rounded-lg border border-grayColor px-4 py-1 flex-center gap-1'>
					<span>{t("filter-title")} </span>
					<CiFilter className=' text-secondry text-lg' />
				</button>

				<div className='mb-6 flex justify-between items-center'>
					<div className=' flex text-2xl  font-semibold '>
						<p>{filters?.location ? `${filters.location} : ` : ""}</p>
						<p>{t("search-result")} </p>
						<p className=' mt-auto text-lg'>{`(${pagination?.totalObjects})`}</p>
					</div>
					<button onClick={() => setMapView(!mapView)} className=' md:hidden xs:flex-center gap-1 bg-secondry rounded-lg text-white px-2 py-1'>
						{mapView ? t("hide-map-view") : t("map-view")} <FaArrowLeftLong />
					</button>
				</div>

				<div className=' grid relative gap-5 xs:grid-cols-1 md:grid-cols-4'>
					<div className={`${openFilter ? "" : "xs:hidden md:col-span-1"} md:col-span-1 md:block`}>
						<div className={`${mapView ? "sticky top-full" : "relative"}`}>
							<div className='flex-1 mb-5 flex-center overflow-hidden w-full h-20 rounded-xl'>
								<img src="/asset/images (1) 1.png" alt="map" className='w-full h-full object-cover ' />
								<button onClick={() => setMapView(!mapView)} className=' absolute flex-center gap-1 bg-secondry rounded-lg text-white px-2 py-1'>
									{mapView ? t("hide-map-view") : t("map-view")} <FaArrowLeftLong />
								</button>
							</div>
							<FiltersSidebar openFilter={openFilter} setOpenFilter={setOpenFilter} filters={filters} setFilters={setFilters} type={"Stay"} />
						</div>
					</div>

					<div className=' xs:col-span-1 md:col-span-3 relative space-y-5'>
						{loading ? <InnerLoading /> :
							searchRuselt?.length === 0 ?
								<div className=' w-full  flex-center flex-col text-center'>
									<img src="/asset/Empty State Illustrations_Light Mode_No Result.png" alt="" />
									<p>{t("no-data")}</p>
								</div> :
								<div>
									<div className={`${mapView ? "hidden" : "block"} space-y-5`}>
										{searchRuselt?.map((stay) => (
											<div key={stay.id} className=' w-full'>
												<PlaceCard place={stay} />
											</div>
										))}
										<Pagination
											currentPage={pagination?.currentPage || 1}
											lastPage={pagination?.lastPage || 1}
											onPageChange={(page) => dispatch(filterPlaces({ filters, page: page || 1 }))}
										/>
									</div>
									<div className={`${mapView ? "block rounded-xl overflow-hidden" : "hidden"}`}>
										<MapView places={searchRuselt} />
									</div>
								</div>
						}
					</div>
				</div>
			</div>
		</div>
	)
}

export default SearchResult
